/** @format */

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  ticket: "",
  password: "",
};

export const FollowReportSlice = createSlice({
  name: "mapPosition",
  initialState: initialState,
  reducers: {
    saveTicketPassword: (state, action) => {
      state.ticket = action.payload.ticket_report;
      state.password = action.payload.password_report;
    },
  },
});

export const { saveTicketPassword } = FollowReportSlice.actions;
export default FollowReportSlice.reducer;
